<template>
    <slot name="cart" v-bind="this"></slot>
</template>

<script>


export default {
    props: {
        deleteUrl: { type: String, required: true },
        csrfToken: { type: String, required: true },
    },
    methods: {
    

        handleDelete(e) {
            e.preventDefault();
            this.$emit('wait', true);


            fetch(this.deleteUrl, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': this.csrfToken,
                    'Accept': 'application/json'
                }
            })
            .then(response => response.json())
            .catch(error => {
                console.error('server error:', error);
                this.$emit('wait', false);
            })
            .finally(() => {
                window.location.reload()
            });
        },
    },
    

};
</script>
